'use strict';

require('./quantity.less');

class Quantity {
    /**
     * В конструктор передается изменямый элемент
     * @param element {HTMLElement}
     */
    constructor(element) {
        this.element = $(element);
        this.block = this.element.closest('.js-quantity-block');
        this.input = this.block.find('.quantity__value');
    }

    /**
     * Изменить количество
     * @param callback {Function}
     * @returns {boolean}
     */
    change(callback) {
        if (this.block.hasClass('js-quantity-block-disabled')) return false;

        let curValue = parseInt(this.input.val());
        if (isNaN(curValue)) {
            curValue = 0;
        }

        if (callback === undefined || callback(this.input, curValue)) {
            this.input.val(curValue);
        }
    }

    /**
     * Увеличить количество
     * @param callback {Function}
     * @returns {boolean}
     */
    plus(callback) {
        if (this.block.hasClass('js-quantity-block-disabled')) return false;

        let curValue = parseInt(this.input.val());
        curValue += 1;

        if (callback === undefined || callback(this.input, curValue)) {
            this.input.val(curValue);
        }
    }

    /**
     * Уменьшить количество
     * @param callback {Function}
     * @returns {boolean}
     */
    minus(callback) {
        if (this.block.hasClass('js-quantity-block-disabled')) return false;

        let curValue = parseInt(this.input.val());
        curValue -= 1;

        if (curValue < 0) curValue = 0;

        if (callback === undefined || callback(this.input, curValue)) {
            this.input.val(curValue);
        }
    }
}
module.exports = Quantity;

jQuery(function() {
    $('.js-quantity-block').each(function() {
        var $block = $(this);
        var $btnMinus = $block.find('.quantity__minus');
        var $btnPlus = $block.find('.quantity__plus');

        //чтобы при быстром кликаньи по кнопкам не срабатывало выделение текста в инпуте
        $btnMinus.add($btnPlus).mousedown(function(e) {
            e.stopPropagation();
            e.preventDefault();
            return false;
        });

        if ($block.hasClass('js-quantity-block-disabled')) return false;
    });

    $(document).on('change', '.js-quantity-input', function() {
        let quantity = new Quantity(this);
        quantity.change();
    });

    $(document).on('click', '.js-quantity-plus', function() {
        let quantity = new Quantity(this);
        quantity.plus();
    });

    $(document).on('click', '.js-quantity-minus', function() {
        let quantity = new Quantity(this);
        quantity.minus();
    });
});



// WEBPACK FOOTER //
// ./blocks/quantity/quantity.js